import { FC } from 'react';
import { format } from 'date-fns';

import Link from 'components/AppSafeLink/AppSafeLink';
import { useTrendingFeed, TrendingLink } from 'context/TrendingFeedContext';
import ScrollArrow from './ScrollArrow';
import { useHorizontalScroll } from './useHorizontalScroll';
import '/public/css/components/trendingFeed.css';

const getDefaultLabel = () => {
  return format(new Date(), 'MMM d, yyyy');
};

const TrendingFeed: FC = () => {
  const data = useTrendingFeed();
  const { scrollRef, canScrollLeft, canScrollRight, scroll } =
    useHorizontalScroll<HTMLDivElement>(data?.links?.length ?? 0);

  // data===null means the client-side fetch hasn't completed yet.
  // Render a placeholder with the same height as the real bar so main doesn't shift.
  if (data === null) {
    return <div className="trending-feed-placeholder" aria-hidden="true" />;
  }

  if (!data?.visible || !data?.links?.length) {
    return null;
  }

  const sortedLinks = [...data.links].sort((a, b) => a.order - b.order);
  const label = data.sectionTitle || getDefaultLabel();

  return (
    <nav className="trending-feed" aria-label={label}>
      <ScrollArrow
        direction="left"
        onClick={() => scroll('left')}
        hidden={!canScrollLeft}
      />
      <div className="trending-feed-inner container" ref={scrollRef}>
        <span className="trending-feed-label">{label}:</span>
        <ul className="trending-feed-list">
          {sortedLinks.map((link: TrendingLink) => (
            <li key={link.order} className="trending-feed-item">
              <Link href={link.url} title={link.title}>
                {link.title}
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <ScrollArrow
        direction="right"
        onClick={() => scroll('right')}
        hidden={!canScrollRight}
      />
    </nav>
  );
};

export default TrendingFeed;
